// API Base URL
const API_BASE_URL = 'https://rawasicrystal.com/api';

// Types and Interfaces
export interface BlogPost {
  id?: number;
  title: string;
  image: string;
  content: string;
  created_at?: string;
  updated_at?: string;
}

export interface SEOData {
  id?: number;
  meta_title?: string;
  meta_description?: string;
  meta_keywords?: string;
  canonical_url?: string;
  robots_index?: boolean;
  robots_follow?: boolean;
  og_title?: string | null;
  og_description?: string;
  og_type?: string | null;
  og_image?: string;
  og_url?: string | null;
  og_site_name?: string | null;
  twitter_card?: string;
  twitter_title?: string | null;
  twitter_description?: string;
  twitter_image?: string | null;
  twitter_site?: string | null;
  twitter_creator?: string | null;
  json_ld?: string;
  language?: string;
  page_type?: string;
  custom_meta_tags?: string;
  created_at?: string;
  updated_at?: string;
}

// API Functions
export const apiService = {
  // Get all blogs
  async getBlogs(): Promise<BlogPost[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/blogs/`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      
      // Process image URLs to ensure they have full domain
      const processedData = data.map((blog: BlogPost) => {
        let imageUrl = blog.image;
        
        // If image URL is relative, make it absolute
        if (imageUrl && !imageUrl.startsWith('http')) {
          // Try different path formats
          if (imageUrl.startsWith('/static/')) {
            // Remove /static/ and try different paths
            const fileName = imageUrl.replace('/static/', '');
            
            // Try these paths:
            // 1. https://rawasicrystal.com/filename (root)
            // 2. https://rawasicrystal.com/static/filename (original)
            // 3. https://rawasicrystal.com/images/filename
            // 4. https://rawasicrystal.com/uploads/filename
            
            imageUrl = `https://rawasicrystal.com/${fileName}`;
          } else if (imageUrl.startsWith('static/')) {
            imageUrl = `https://rawasicrystal.com/${imageUrl}`;
          } else {
            imageUrl = `https://rawasicrystal.com/static/${imageUrl}`;
          }
        }
        
        return {
          ...blog,
          image: imageUrl
        };
      });
      
      return processedData;
    } catch (error) {
      
      throw error;
    }
  },

  // Get SEO data
  async getSEO(): Promise<SEOData> {
    try {
      const response = await fetch(`${API_BASE_URL}/seo/`);
      if (!response.ok) {
        // Return default SEO data if API fails
        return {
          meta_title: 'Rawasi Kristal - Interior Design & Decorations',
          meta_description: 'Professional interior design and decoration services in Saudi Arabia',
          meta_keywords: 'interior design, decoration, Saudi Arabia, Rawasi Kristal',
          canonical_url: 'https://rawasicrystal.com',
          og_title: 'Rawasi Kristal - Interior Design & Decorations',
          og_description: 'Professional interior design and decoration services in Saudi Arabia',
          og_type: 'website',
          twitter_card: 'summary_large_image'
        };
      }
      const data = await response.json();
      return Array.isArray(data) ? data[0] : data;
    } catch (error) {
      // Return default SEO data on error
      return {
        meta_title: 'Rawasi Kristal - Interior Design & Decorations',
        meta_description: 'Professional interior design and decoration services in Saudi Arabia',
        meta_keywords: 'interior design, decoration, Saudi Arabia, Rawasi Kristal',
        canonical_url: 'https://rawasicrystal.com',
        og_title: 'Rawasi Kristal - Interior Design & Decorations',
        og_description: 'Professional interior design and decoration services in Saudi Arabia',
        og_type: 'website',
        twitter_card: 'summary_large_image'
      };
    }
  }
};

export default apiService; 